import React from 'react';

import HomePage from './home';

const IndexPage = () => <HomePage />;

export default IndexPage;
